import { render, staticRenderFns } from "./ScaryModal.vue?vue&type=template&id=79545fa0&"
import script from "./ScaryModal.vue?vue&type=script&lang=js&"
export * from "./ScaryModal.vue?vue&type=script&lang=js&"
import style0 from "./ScaryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports